export const rawsColumns = [
  {
    title: "原料名称",
    dataIndex: "name",
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "代码",
    dataIndex: "code",
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "次优解（%）",
    dataIndex: "percentage",
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: "colorSpan" },
  },
  {
    title: "最小值",
    dataIndex: "minValue",
    width: 120,
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: "minValue" },
  },
  {
    title: "最大值",
    dataIndex: "maxValue",
    width: 120,
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: "maxValue" },
  },
]
export const indexColumns = [
  {
    title: "指标名称",
    dataIndex: "nutritionName",
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "代码",
    dataIndex: "nutritionCode",
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "次优解",
    dataIndex: "content",
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: "colorSpan" },
  },
  {
    title: "最小值",
    dataIndex: "minValue",
    width: 120,
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: "minValue" },
  },
  {
    title: "最大值",
    dataIndex: "maxValue",
    width: 120,
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: "maxValue" },
  },
]